<!-- Dynamic snackbar component outlet -->
<ng-template #snackbarOutlet />
